import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { forwardRef, useState, useContext } from 'react';
import cx from 'classnames';
import { Styled } from './Carousel.styles';
import Controls from './Controls';
import { FeatureHeaderContext } from '../FeatureHeader';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var useFeatureHeaderContext = function useFeatureHeaderContext() {
  return useContext(FeatureHeaderContext);
};

var Carousel = forwardRef(function (_ref, ref) {
  var _data$activeIndex, _data$actions$start, _data$actions;

  var data = _ref.data;

  var _useFeatureHeaderCont = useFeatureHeaderContext(),
      level = _useFeatureHeaderCont.level,
      slideHasImage = _useFeatureHeaderCont.slideHasImage;

  var _useState = useState((_data$activeIndex = data === null || data === void 0 ? void 0 : data.activeIndex) !== null && _data$activeIndex !== void 0 ? _data$activeIndex : 0),
      _useState2 = _slicedToArray(_useState, 2),
      activeIndex = _useState2[0],
      setActiveIndex = _useState2[1];

  var actions = data === null || data === void 0 ? void 0 : data.actions;
  var slides = data === null || data === void 0 ? void 0 : data.slides;
  var slideCount = slides.length;
  var hasStartAction = (_data$actions$start = data === null || data === void 0 ? void 0 : (_data$actions = data.actions) === null || _data$actions === void 0 ? void 0 : _data$actions.start) !== null && _data$actions$start !== void 0 ? _data$actions$start : false;

  var goToSlide = function goToSlide(slideIndex) {
    setActiveIndex(slideIndex);
  };

  return _jsxs(_Fragment, {
    children: [_jsx(Styled.Slider, {
      ref: ref,
      activeIndex: activeIndex,
      hasNavigation: false,
      hasPaging: false,
      children: slides.map(function (item, index) {
        var _cx;

        var currentSlide = hasStartAction ? index : index + 1;
        return _jsx(Styled.Slider.Slide, {
          children: _jsxs(Styled.SlideContent, {
            className: "SlideContent",
            children: [_jsxs(Styled.Body, {
              slideHasImage: slideHasImage,
              children: [slideCount > 1 && currentSlide >= 1 && _jsxs(Styled.Counter, {
                children: [currentSlide, " of", ' ', hasStartAction ? slideCount - 1 : slideCount]
              }), _jsx(Styled.Title, {
                children: item.title
              }), item.description && _jsx(Styled.Description, {
                children: _jsx(Styled.ScrollPane, {
                  className: cx((_cx = {}, _defineProperty(_cx, "os-host-flexbox", true), _defineProperty(_cx, "os-theme-light", level === 'one'), _cx)),
                  children: item.description
                })
              })]
            }), _jsx(Styled.Image, {
              children: item.image && _jsx("img", {
                alt: "",
                src: item.image
              })
            })]
          })
        }, index);
      })
    }), _jsx(Controls, {
      activeIndex: activeIndex,
      actions: actions,
      hasStartAction: hasStartAction,
      goToSlide: goToSlide,
      slideCount: slideCount
    })]
  });
});
export default Carousel;